import axios from 'axios';

const ROOT_URL = "https://todis.transport-community.org/api/";
//const ROOT_URL = "http://localhost:8080/api/";

class ExportService {

    async getAttributes(filter) {
        try {
            const response = await axios.post(ROOT_URL + `export/attributes`, filter);
            //console.log('response.data:', response.data);
            return response.data.data;
        } catch (error) {
            //console.error('Error in getAttributes:', error);
            throw new Error('Failed to get Attributes');
        }
    }

    async getRelatedTables(filter) {
        try {
            const response = await axios.post(ROOT_URL + `export/relatedTables`, filter);
            //console.log('response.data:', response.data);
            return response.data.data;
        } catch (error) {
            //console.error('Error in getRelatedTables:', error);
            throw new Error('Failed to get Related Tables');
        }
    }

    async getRelatedLayers(filter) {
        try {
            const response = await axios.post(ROOT_URL + `export/layers`, filter);
            //console.log('response.data:', response.data);
            return response.data.data;
        } catch (error) {
            //console.error('Error in getRelatedLayers:', error);
            throw new Error('Failed to get Related Layers');
        }
    }

    async getRelatedAttributes(filter) {
        try {
            const response = await axios.post(ROOT_URL + `export/results`, filter);
            //console.log('response.data:', response.data);
            return response.data.data;
        } catch (error) {
            //console.error('Error in getRelatedAttributes:', error);
            throw new Error('Failed to get Related Attributes');
        }
    }

}

export default ExportService;